import { User, UserRole } from "./user.types";
import { PaymentOrder } from "./payment.types.ts";
import { TrialOfferUnit } from "./trial-offer.types.ts";

export enum AffiliateStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
}

export type Affiliate = {
  id: string;
  fullName: string;
  email: string;
  phoneNumber: string;
  status: AffiliateStatus;
  socialUrl: string;
  museReferralPaymentCents: number;
  alphaReferralPaymentBps: number;
  bankAccountCredentials: string;
  earnings: number;
  duePayment: number;
  createdAt: string;
  referralsCounts: Record<UserRole, number>;
  user?: User;
  trialOfferAmount?: number;
  trialOfferUnit?: TrialOfferUnit;
};

export type AffiliatePayment = {
  id: string;
  affiliate: Affiliate;
  type: "muse-approval" | "alpha-payment";
  user?: User;
  amountCents: number;
  isPaid: false;
  paidAt: string;
  actualPaidAt: string;
  order?: PaymentOrder;
  createdAt: string;
};

export type AffiliatePayout = {
  year: number;
  month: number;
  amountCents: number;
  paidAt: string;
};

export type AffiliateEarning = {
  year: number;
  month: number;
  amountCents: number;
};
